module.exports = __webpack_public_path__ + "assets/img/388b9ec4bafb3a276224023c689c22d9.png";